/**
 * Gets a translation from the global tiofSettings object
 * @param key Dot-notation path to the translation (e.g., 'regoLookup.inputLabel')
 * @param defaultText Text to return if translation is not found
 * @returns The translated text or default text
 */
export var getTranslation = function (key, defaultText) {
    var _a;
    // Safely access the global settings object
    if (typeof window === 'undefined' || !((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.i18n)) {
        return defaultText;
    }
    var i18n = window.tiofSettings.i18n;
    var keys = key.split('.');
    var value = i18n;
    // Navigate through the nested object using the key path
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var k = keys_1[_i];
        if (!value || typeof value !== 'object' || !(k in value)) {
            return defaultText;
        }
        value = value[k];
    }
    return value || defaultText;
};
